export default {
    primary: "#E9B16D",
    secondary: "#76C09B",
    background: "#1F1F1F",
};